module.exports = __webpack_public_path__ + "img/05-min.106aa838.jpg";